/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    func, shape, string, number, arrayOf,
} from 'prop-types';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import { isEmpty } from '../../../utils/object';
import { formatPhoneNumber } from '../../../utils/formater';
import EventDispatcher from '../../../state/reducers/EventDispatcher';
import { countryISOAlfa3Codes } from '../../../state/constants/Countries';
import configENV from '../../../config';

const { PERSIST_KEY } = configENV;

class DesktopAddressDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {},
        };
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps = (props) => {
        const {
            singleAddressGet: { data },
            addForm,
        } = props;
        if (typeof data !== 'undefined') {
            this.setState({ data });
        }
        if (addForm === 'AddForm') {
            this.setState({ data: {} });
        }
    };

    showDataAdress=() => {
        const {
            addForm, singleAddressGet: { data: dataProp },
            handleDesktopEditAddressClicked, recipients,
        } = this.props;
        const { data: dataState } = this.state;
        const dataObj = dataProp || dataState;
        const isAddressFormShown = (addForm !== '');
        const selectOrAddAddressCopy = isEmpty(recipients) ? 'Please add a new address.' : 'Please select an address.';
        if (!isEmpty(dataObj) && addForm !== 'AddForm') {
            const {
                FirstName, LastName, Addresses, PhoneNumber, EmployerName,
            } = dataObj;
            // Prevent error if Addresses is an empty array
            if (isEmpty(Addresses)) return <div className={`noAddressSelected ${isAddressFormShown ? 'display-none' : ''}`}>{selectOrAddAddressCopy}</div>;
            const recipientAddresses = Addresses.filter((a) => a.AddressType !== 'Billing');
            const {
                AddressId, Country, AddressBookEntryId, AddressLineOne, AddressLineTwo, City, StateProvince, PostalCode,
            } = recipientAddresses[0];
            return (
                <>
                    <div className={`addressDetails ${isAddressFormShown ? 'display-none' : ''}`}>
                        <div className="addressDetailsInner">
                            <div className="display-flex">
                                <div className="label">
                                    <span>Name:</span>
                                </div>
                                <div className="content">
                                    <span>{[
                                        FirstName,
                                        LastName,
                                    ].join(', ')}
                                    </span>
                                </div>
                            </div>
                            <div className={`display-flex ${!EmployerName ? 'display-none' : ''}`}>
                                <div className="label">
                                    <span>Company:</span>
                                </div>
                                <div className="content">
                                    <span>{EmployerName}</span>
                                </div>
                            </div>
                            <div className="display-flex">
                                <div className="label alignTop">
                                    <span>Address:</span>
                                </div>
                                <div className="content">
                                    <span>{[
                                        AddressLineOne,
                                        AddressLineTwo || ''].join(', ')}
                                    </span>
                                    <span> {[
                                        City,
                                        StateProvince,
                                    ].join(', ')}{' '}{PostalCode}
                                    </span>
                                    <span>{countryISOAlfa3Codes[Country]}</span>
                                </div>
                            </div>
                            <div className="display-flex">
                                <div className="label">
                                    <span>Phone:</span>
                                </div>
                                <div className="content">
                                    <span>{formatPhoneNumber(PhoneNumber)}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`editButton ${isAddressFormShown ? 'display-none' : ''}`}>
                        <Button
                            onClick={() => handleDesktopEditAddressClicked(dataObj, AddressBookEntryId, AddressId)}
                            className="secondary"
                        >
                            Edit
                        </Button>
                    </div>
                </>
            );
        }
        return <div className={`noAddressSelected ${isAddressFormShown ? 'display-none' : ''}`}>{selectOrAddAddressCopy}</div>;
    }

    render() {
        return (
            <>
                {this.showDataAdress()}

            </>
        );
    }
}

DesktopAddressDetail.defaultProps = {
    singleAddressGet: {},
    recipients: [],
    addForm: '',
    handleDesktopEditAddressClicked: () => {},

};
DesktopAddressDetail.propTypes = {
    addForm: string,
    singleAddressGet: shape({
        data: shape({
            AddressBookEntryId: string,
            ContactId: number,
            FirstName: string,
            LastName: string,
            NickName: string,
            LastUpdateDate: string,
            NumberOfAddresses: number,
            Addresses: arrayOf(
                shape({
                    AddressId: number,
                    AddressBookEntryId: string,
                    AddressType: string,
                    AddressLineOne: string,
                    AddressLineTwo: string,
                    City: string,
                    StateProvince: string,
                    PostalCode: string,
                    Country: string,
                    ContactId: number,
                }),
            ),
        }),
    }),
    recipients: arrayOf(
        shape({
            AddressBookEntryId: string,
            ContactId: number,
            FirstName: string,
            LastName: string,
            RelationShip: string,
            NickName: string,
            LastUpdateDate: string,
            EmployerName: string,
            NumberOfAddresses: number,
            Addresses: arrayOf(
                shape({
                    AddressId: number,
                    AddressBookEntryId: string,
                    AddressType: string,
                    AddressLineOne: string,
                    AddressLineTwo: string,
                    City: string,
                    StateProvince: string,
                    PostalCode: string,
                    Country: string,
                    ContactId: number,
                }),
            ),
        }),
    ),
    handleDesktopEditAddressClicked: func,
};
const mapStateToProps = (state) => {
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        singleAddressGet: newState.singleAddressGet,
        recipients: newState.recipients,
    };
};
const mapDispatchToProps = (dispatch) => ({
    handleDesktopEditAddressClicked: (recipient, AddressBookEntryId, AddressId) => dispatch(EventDispatcher.handleDesktopEditAddressClicked(
        recipient,
        AddressBookEntryId,
        AddressId,
        'RecipientForm',
    )),
});

export default  connect(
    mapStateToProps,
    mapDispatchToProps,
)(DesktopAddressDetail);
